import React from 'react';
import {
  ColorValue,
  StatusBar, StatusBarStyle,
} from 'react-native';
import build from '../../config/build';

const { isElite } = build.variant;

interface IProps {
  barStyle: StatusBarStyle;
  backgroundColor?: ColorValue;
}

export const StatusBarComponent = ({barStyle, backgroundColor}: IProps) => {
  return isElite ? <></> : <StatusBar backgroundColor={backgroundColor} barStyle={barStyle}/>
};
